// Mock data for Just Bengali Restaurant
import chickenChop from "./assets/ChikenChop.png";
import chickenChop1 from "./assets/ChikenChop.png";
import eggdevil from "./assets/eggDevil.png";
import Jhal from "./assets/Jhal.png";
import MuttonKoshaSpecial from "./assets/MuttonKosha.png";
import Benguni from "./assets/Dish/Begun bhaaja [2 pieces].png";
import PaneerFinger  from "./assets/Dish/PaneerFinger(6 pc).jpg";
import FishChop from "./assets/Dish/Fish Chop.png";
import FishKabiraji from "./assets/Dish/Bhetki fish kabiraji [1 piece].png";
import JhooriAloo from "./assets/Dish/Jhoori Aloo Bhaja.png";
import Sukto from "./assets/Dish/Sukto.png";
import DhokarDalna from "./assets/Dish/Dhokar dalna [6 pieces].png";
import MuriGhonto from "./assets/Dish/Muri Ghonto.png";
import PabdaJhal from "./assets/Dish/Pabda jhal.png";
import ChingriMalai from "./assets/Dish/Chingri malai curry [6 pieces].png";
import BhapaIlish from "./assets/Dish/1.png";
import KoiMacherTok from "./assets/Dish/Koi Macher Tok.png";
import PomfretShorshe from "./assets/Dish/Pomfret Shorshe Jhal.png";
import PrawnsMasala from "./assets/Dish/Prawns Masala (6 pc.png";
import ChingriBhapa from "./assets/Dish/Chingri Bhapa.png";
import ChickenDukbanglow from "./assets/Dish/Chicken dukbanglow [4 pieces].png";
import ChickenKosha from "./assets/Dish/Chicken kosha [4 pieces].png";
import ChickenRezala from "./assets/Dish/Chicken kosha [4 pieces].png";
import AamTokDal from "./assets/Dish/Aam Tok Dal (Seasonal).png";
import MuttonDukbanglow from "./assets/Dish/Mutton Dukbanglow.png";
import MuttonRezala from "./assets/Dish/Mutton Rezala.png";
import MacherMathaDiyeDal from "./assets/Dish/Macher Matha Diye Dal.png";
import MuttonBhuna from "./assets/Dish/Mutton Bhuna.png";
import GondharajChicken from "./assets/Dish/Gondharaj Chicken.png";
import hero from "./assets/restro.png"
import img1 from "./assets/gallary/1.jpg";
import img2 from "./assets/gallary/2.jpg";
import img3 from "./assets/gallary/3.jpg";
import img4 from "./assets/gallary/5.jpg";
import img5 from "./assets/gallary/unnamed.jpg";
import img6 from "./assets/gallary/6.jpg";
export const heroImages = {
  main: hero,
  thali: "https://images.unsplash.com/photo-1743674453123-93356ade2891?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxCZW5nYWxpJTIwZm9vZHxlbnwwfHx8fDE3NzM3MjI0NjF8MA&ixlib=rb-4.1.0&q=85"
};

export const specialties = [
  {
    id: 1,
    name: "Pabda Jhal",
    title: "Pabda Jhal",
    description: "A whole pabda fish slowly cooked in mustard & tomato Onion mixture gravy",
    // price: "₹450",
    image: Jhal,
    category: "Seafood"
  },
  {
    id: 2,
    name: "Chicken Chop",
    title: "Spicy Chicken Chop Special",
    description: "A mouthwatering chicken chop marinated in a blend of spicy seasonings, grilled or pan-seared for a smoky finish. Perfectly paired with your favorite sides.",
    // price: "₹420",
    image: chickenChop1,
    category: "Main Course"
  },
  {
    id: 3,
    name: "Egg Devil",
    title: "Egg Devil",
    description: "Boiled egg wrapped with mix veggies, Coated with bread crumbs & deep fried",
    // price: "₹520",
    image: eggdevil,
    category: "Egg"
  },
  // {
  //   id: 4,
  //   name: "Mutton Kosha",
  //   title: "Mutton Kosha",
  //   description: "Classic Bengali sweet yogurt made from caramelized milk and hung curd",
    // price: "₹120",
  //   image: MuttonKosha,
  //   category: "Desserts"
  // }
];

export const menuCategories = [
  {
    id: 1,
    category: "Starters",
    items: [
      {
        id: 101,
        name: "Begun Bhaaja",
        description: "Begun Bhaja is a simple Bengali dish of sliced eggplant marinated with turmeric and salt",
        // price: "₹80",
          image: Benguni,
        isVeg: true
      },
      {
        id: 102,
        name: "Jhoori Aloo Bhaja",
        description: "hoori Aloo Bhaja is a classic Bengali-style crispy potato fry known for its ultra-thin, matchstick-like cuts and light, crunchy texture.",
        // price: "₹100",
          image: JhooriAloo,
        isVeg: true
      },
      {
        id: 103,
        name: "Paneer Finger (6 pc)",
        description: "Paneer Finger is a popular Indian appetizer ",
        // price: "₹150",
          image: PaneerFinger,
        isVeg: true
      },
      {
        id: 104,
        name: "Fish Chop",
        description: "Fish Chop is a beloved Bengali snack known for its rich, spicy filling and crisp, golden coating—often enjoyed as a tea-time treat or street-food favorite, especially around Kolkata.",
        // price: "₹220",
          image: FishChop,
        isVeg: false
      },
      {
        id: 105,
        name: "Fish Kabiraji",
        description: "Fish Cutlet deep fried with lacy egg nest, A bengali favourite, Don't count the calories",
        // price: "₹250",
          image: FishKabiraji,
        isVeg: false
      },
      {
        id: 106,
        name: "Chicken Chop",
        description: "Keema chicken marinated with authentic bengali spice , Crumbed & deep fried",
        // price: "₹220",
          image: chickenChop1,
        isVeg: false
      },
     
    ]
  },
  {
    id: 2,
    category: "Main Course",
    items: [
      {
        id: 201,
        name: "Sukto",
        description: "Classic bengali mixed vegetables with coconut& Pinch of Mustard",
        // price: "₹140",
          image: Sukto,
        isVeg: true
      },
      {
        id: 202,
        name: "Dhokar Dalna",
        description: "Lentil cakes soaked in delicious bengali style curry",
        // price: "₹150",
          image: DhokarDalna,
        isVeg: true
      },
      {
        id: 203,
        name: "Muri Ghonto",
        description: "We cook it with Rice and Fish head (mostly Rehu Fish/ Rui Mach or Katla fish).",
        // price: "₹250",
          image: MuriGhonto,
        isVeg: false
      },
      {
        id: 204,
        name: "Pabda Jhal",
        description: "A whole pabda fish slowly cooked in mustard & tomato Onion mixture gravy",
        // price: "₹280",
          image: PabdaJhal,

        isVeg: true
      }
    ]
  },
  {
    id: 3,
    category: "Seafood Specials",
    items: [
      {
        id: 301,
        name: "Chingri Malai Curry",
        description: "A bengali classic prawns cooked in rich coconut milk curry, with a pinch of sweetness",
        // price: "₹375",
          image: ChingriMalai,
        isVeg: false
      },
      {
        id: 302,
        name: "Bhapa Ilish",
        description: "SFresh Hilsha slices are cooked with brinjal pieces and green chillies in mustard oil using minimal spices",
        // price: "₹700",
          image: BhapaIlish,
        isVeg: false
      },
      {
        id: 303,
        name: "Koi Macher Tok",
        description: "Climbing perch in tangy tamarind gravy",
        // price: "₹320",
          image: KoiMacherTok,
        isVeg: false
      },
      {
        id: 304,
        name: "Pomfret Shorshe Jhal",
        description: "A whole fresh pomfret fish slowly cooked in mustrad gravy & Mustard Oil",
        // price: "₹500",
          image: PomfretShorshe,
        isVeg: false
      }
    ]
  },
  {
    id: 4,
    category: "Prawn Specials",
    items: [
      {
        id: 401,
        name: "Prawns Masala (6 pc)",
        description: "Medium Size Prawns cooked in Thick & rich gravy, Flavoured of garam Masala ",
        // price: "₹370",
          image: PrawnsMasala,
        isVeg: false
      },
      {
        id: 402,
        name: "Chingri Bhapa ",
        description: "Prawns Cooked in Mustard base creamy gravy, Steam to perfection",
        // price: "₹350",
          image: ChingriBhapa,
        isVeg: false
      },
    ]
  },
  {
    id: 5,
    category: "Chicken Specials",
    items: [
      {
        id: 501,
        name: "Chicken Dukbanglow",
        description: "Tender Chicken & egg cooked in tangy & spicy gravy, An authentic flavoured of bengali cuisine",
        // price: "₹280",
          image: ChickenDukbanglow,
        isVeg: false
      },
      {
        id: 502,
        name: "Chicken Kosha",
        description: "Tender chicken slowly cooked in thick & rich gravy with garam masala flavoured",
        // price: "₹270",
          image: ChickenKosha,
        isVeg: false
      },
      {
        id: 503,
        name: "Chicken Rezala",
        description: "Chicken cooked in a delicate gravy with whole black paper & whole dry chillies, flavoured of cardamon & cinnamon",
        // price: "₹280",
          image: ChickenRezala,
        isVeg: false
      },
      {
        id: 504,
        name: "Gondharaj Chicken ",
        description: "A fragrant and flavorful Bengali dish made using the aromatic Gondhoraj lebu (a special lime native to Bengal)",
        // price: "₹280",
          image: GondharajChicken,
        isVeg: false
      }
    ]
  },
  {
    id: 6,
    category: "Mutton Specials",
    items: [
      {
        id: 601,
        name: "Mutton Dukbanglow",
        description: "Tender Mutton & egg cooked in tangy & spicy gravy, An authentic flavoured of bengali cuisine",
        // price: "₹470",
          image: MuttonDukbanglow,
        isVeg: false
      },
      {
        id: 602,
        name: "Mutton Kosha ",
        description: "Mutton slowly cooked in thick & rich gravy, flavoured of garam masala",
        // price: "₹470",
          image: MuttonKoshaSpecial,
        isVeg: false
      },
      {
        id: 603,
        name: "Mutton Rezala",
        description: "Mutton cooked in a delicate gravy with whole black paper & whole dry chillies, flavoured of cardamon & cinnamon",
        // price: "₹450",
          image: MuttonRezala,
        isVeg: false
      },
      {
        id: 604,
        name: "Mutton Bhuna",
        description: "In Bengali cuisine is a rich and flavorful dish made by slow-cooking tender pieces of mutton with onions, garlic, ginger, and blend of aromatic spices. ",
        // price: "₹500",
          image: MuttonBhuna,
        isVeg: false
      }
    ]
  },
  {
    id: 7,
    category: "Dal Specials",
    items: [
      {
        id: 701,
        name: "Aam Tok Dal (Seasonal)",
        description: "TSplit Moog dal with green mango",
        // price: "₹120",
          image: AamTokDal,
        isVeg: true
      },
      {
        id: 702,
        name: "Macher Matha Diye Dal",
        description: "Split moong dal with fish head",
        // price: "₹160",
        image: MacherMathaDiyeDal,
        isVeg: false
      },
      {
        id: 703,
        name: "Cholar Dal",
        description: "Chana dal tempered with spices, fried Coconut & ghee",
        // price: "₹450",
          // image: CholarDal,
        isVeg: true
      }
    ]
  }
];



export const galleryImages = [
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  "https://images.unsplash.com/photo-1743674453123-93356ade2891",
  "https://images.unsplash.com/photo-1588644525273-f37b60d78512",
  "https://images.unsplash.com/photo-1547573854-74d2a71d0826",
  "https://images.unsplash.com/photo-1582228096960-7f5d2ec4aa8e",
  "https://images.unsplash.com/photo-1536305030588-45dc07a2a372",
  "https://images.unsplash.com/photo-1574178778020-e3ac6b70b358"
];

export const whyChooseUs = [
  {
    id: 1,
    title: "Authentic Bengali Recipes",
    description: "Traditional family recipes passed down through generations"
  },
  {
    id: 2,
    title: "Fresh & Quality Ingredients",
    description: "Sourced daily to ensure the highest quality and taste"
  },
  {
    id: 3,
    title: "Cozy Family-Friendly Ambience",
    description: "Warm atmosphere perfect for family gatherings and celebrations"
  },
  {
    id: 4,
    title: "Fast Service & Online Ordering",
    description: "Quick service with convenient online ordering options"
  }
];

export const contactInfo = {
  Area:"Kharadi",
  location: "Sr. No. 22/1/8, Mundhwa - Kharadi Rd, near Bank of Baroda, near Shiv Shakti Restaurant, Thite Vasti, Thite Nagar, Kharadi, Pune, Maharashtra 411014",
  
  phone: "+91 84848 75750",
  email: "info@justbengali.com",
  hours: "Mon–Sun: 11 AM – 11 PM"
};
export const contactInfo1 = {
  Area:"Hadapsar",
  location: "Shop No -11 (Gr. Floor, Eravlle Business Zone, behind Amanora Mall, beside Tupe Corner, sreenagar society, Amanora Park Town, Hadapsar, Pune, Maharashtra 411028",
  phone: "+91 8600026184",

    email: "info@justbengali.com",
  hours: "Mon–Sun: 11 AM – 11 PM"
};
